import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

/**
 * OfflineBanner — shows a banner when the user is offline.
 *
 * Displays the message required by Req 13.3:
 * "Không có kết nối mạng và không có dữ liệu đã lưu"
 *
 * When the Service Worker has a valid cache (Req 13.2), Workbox transparently
 * serves cached responses so the app continues to work; this banner still
 * informs the user that the network is unavailable.
 *
 * When the connection is restored, SWR's `revalidateOnReconnect: true` (Req 13.4)
 * automatically refetches fresh data.
 *
 * Requirements: 13.2, 13.3, 13.4
 */
export const OfflineBanner: React.FC = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <Box
      sx={{ position: 'fixed', bottom: 16, left: '50%', transform: 'translateX(-50%)', zIndex: 9999, minWidth: 300 }}
      role="status"
      aria-live="polite"
    >
      <Alert severity="warning">
        Không có kết nối mạng và không có dữ liệu đã lưu
      </Alert>
    </Box>
  );
};
